import React, {useEffect} from "react";
import {
    AnnouncementDetail,
    AnnouncementIcon,
    LabelBlock,
    Title,
    Wrapper
} from "./AnnouncementRow.styles";
import AnnouncementLabelIcon from "../../../../public/images/announcement-label-icon.svg";
import {Spin, Tooltip} from "antd";

const MOCK_DATA =
    'Kuryelerimiz işletmenizdeyken kuyrukta bekleyen siparişi talep edebilir. Sipariş detayından bulunan "Onayla" butonuyla operasyona bağlanmadan siparişi kuryeye atayabilirsiniz.';
export const AnnouncementRow = () => {
    const [data, setData] = React.useState(MOCK_DATA);
    const [loading, setLoading] = React.useState(true);
    const fetchData = () => {};
    useEffect(() => {
        fetchData();
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);

    return (
        <Wrapper>
            <LabelBlock>
                <AnnouncementIcon src={AnnouncementLabelIcon} />
                <Title>Duyurular</Title>
            </LabelBlock>
            <AnnouncementDetail>
                {loading ? (
                    <Spin />
                ) : (
                    <Tooltip title={data} placement="bottom">
                        {data}
                    </Tooltip>
                )}
            </AnnouncementDetail>
        </Wrapper>
    );
};
